module.exports = __webpack_public_path__ + "img/Rectangle 31.5c9f2349.png";